import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HBorderPanel = _resolveComponent("HBorderPanel")!
  const _component_HContainer = _resolveComponent("HContainer")!

  return (_ctx.shippingAddress)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_HContainer, null, {
          content: _withCtx(() => [
            _createVNode(_component_HBorderPanel, null, {
              heading: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.heading), 1)
              ]),
              body: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shippingAddress, (val, key) => {
                  return (_openBlock(), _createElementBlock("p", {
                    key: key,
                    innerHTML: val
                  }, null, 8, _hoisted_2))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}